module.exports = __webpack_public_path__ + "media/images/home/intro02-fa6456d01399bff3804f78e868a89680.svg";